import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listAssignedProductionOrders } from "../../api/productionOrders";

export default function OperatorAssignedOrdersPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  function load() {
    setLoading(true);
    listAssignedProductionOrders()
      .then((rows) => setItems(rows || []))
      .catch((err) => {
        console.error("ASSIGNED ORDERS LOAD ERROR", err);
        alert("Atanan iş emirleri yüklenemedi");
      })
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    load();
  }, []);

  return (
    <div>
      <h2>Atanan İş Emirlerim</h2>

      <button onClick={load} disabled={loading}>
        {loading ? "Yükleniyor..." : "Yenile"}
      </button>

      <table style={{ width: "100%", marginTop: 12 }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Emir No</th>
            <th>Ürün</th>
            <th>Planlanan</th>
            <th>Durum</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {items.length ? (
            items.map((x) => (
              <tr key={x.id}>
                <td>{x.id}</td>
                <td>{x.order_no}</td>
                <td>{x.product_name}</td>
                <td>{x.planned_qty}</td>
                <td>{x.status}</td>
                <td style={{ textAlign: "right" }}>
                  <button onClick={() => navigate(`/operator/orders/${x.id}`)}>Raporla</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} style={{ opacity: 0.7 }}>
                Kayıt bulunamadı
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

